import error from './error';
import setting from "./setting";
import patient from "./patient";
import therapists from "./therapists";
import room from "./room";
import contact from "./contacts";
import messages from "./messages"

export default {
	error,
	setting,
	patient,
	contact,
	therapists,
	room,
	messages
};
